import { Link } from "react-router-dom";
import { ArrowLeft, Home, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const IconBtn = ({ to, onClick, label, testid, children }) => {
  const cls = "w-10 h-10 rounded-full flex items-center justify-center c-card hover:opacity-80 transition-opacity";
  return to ? (
    <Link to={to} aria-label={label} data-testid={testid} className={cls}>{children}</Link>
  ) : (
    <button onClick={onClick} aria-label={label} data-testid={testid} className={cls}>{children}</button>
  );
};

export const AppHeader = ({ title, eyebrow, back, home = true, showLogout = false, titleTestid = "header-title", right = null }) => {
  const { user, logout, isOwner } = useAuth();
  return (
    <header className="safe-top sticky top-0 z-30 backdrop-blur-xl bg-[color-mix(in_srgb,var(--c-bg)_85%,transparent)] px-4 pb-3">
      <div className="flex items-center gap-3">
        {back && <IconBtn to={back} label="Atrás" testid="header-back-btn"><ArrowLeft className="w-5 h-5" /></IconBtn>}
        <div className="flex-1 min-w-0">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase c-muted truncate" data-testid="header-eyebrow">{eyebrow ?? user?.name}</p>
          <h1 data-testid={titleTestid} className="font-heading text-xl font-extrabold tracking-tight truncate">{title}</h1>
        </div>
        {right}
        {home && isOwner && <IconBtn to="/" label="Inicio" testid="header-home-btn"><Home className="w-5 h-5" /></IconBtn>}
        {showLogout && <IconBtn onClick={logout} label="Cerrar sesión" testid="header-logout-btn"><LogOut className="w-5 h-5" /></IconBtn>}
      </div>
    </header>
  );
};
